import SitePage                   from 'components/Site/Page';
import SignupView                 from 'views/Site/Signup';
import { useTranslation }         from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const SignupPage = (props) => {
  const { t } = useTranslation('common');
  const title = t('site.pages.signupTitle');

  return (
    <SitePage 
      {...props}
      title={title}
      siteViewClass="flex-column"
      siteViewContentClass="flex-center"
    >
      <SignupView title={title}/>
    </SitePage>
  )
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common'])
    }
  }
}

export default SignupPage;